// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#collection-link-file-dropzone[data-v-1a9c308f]{min-height:138px}#collection-link-file-add-files[data-v-1a9c308f]{padding-top:55px}.dz-uploaded-file[data-v-1a9c308f]{cursor:default}#collection-link-file-add-more-files[data-v-1a9c308f]{position:absolute;left:15px;bottom:16px}.progress-display[data-v-1a9c308f]{position:absolute;left:15px;bottom:10px;width:calc(100% - 100px)}", ""]);
// Exports
module.exports = exports;
